<template>
  <div>
    <template v-if="showActionControls">
      <div
        class="pa-3"
        v-for="c in contexts"
        v-show="c.groupId === group.id"
        :key="c.id"
      >
        <action-presentation-controls
          :context="c"
          :actionData="actionData"
          @update="updateAction(c)"
          @close="closeAction(c)"
        />
      </div>
    </template>

    <portal to="receivedAction">
      <action-presentation-content
        v-if="showActionContent(receivedState)"
        :class="actionContentClass"
        :state="receivedState"
      />
    </portal>
  </div>
</template>

<script>
import GenericAction from '../GenericAction';
import ActionPresentationControls from './ActionPresentationControls';
import ActionPresentationContent from './ActionPresentationContent';

export default {
  name: 'ActionPresentation',
  mixins: [GenericAction],
  components: {
    ActionPresentationControls,
    ActionPresentationContent,
  },
  data() {
    return {
      receivedState: {},
    };
  },
  methods: {
    selected() {
      this.addContext({
        show: false,
        presentationUrl: '',
        presentationState: null,
        customUrl: '',
      });
    },

    updateAction(context) {
      this.api.trigger('stateChange', { contexts: this.contexts });
      this.updateParticipants(context);
    },

    received(data) {
      this.receivedState = data;
    },
  },
};
</script>

<style lang="less">
.presentation-iframe__wrap {
  background-color: #fff;
  position: relative;
  overflow: hidden;
  &:before {
    content: '';
    position: absolute;
    z-index: 1;
    bottom: 0;
    right: 0;
    height: 150px;
    width: 150px;
  }
  &:after {
    content: '';
    display: block;
    padding-bottom: 56%;
  }
  iframe {
    position: absolute;
    top: 0;
    left: 0;
    height: calc(100% + 36px);
    width: 100%;
  }
}
</style>
